import { ClaimAction } from "./types";

export const createClaim = (payload) =>
  ({
    type: ClaimAction.CREATE_CLAIM,
    payload,
  }) as const;

export const insertClaimItems = (payload) =>
  ({
    type: ClaimAction.INSERT_CLAIM_ITEMS,
    payload,
  }) as const;

export const removeClaimItem = (payload) =>
  ({
    type: ClaimAction.REMOVE_CLAIM_ITEM,
    payload,
  }) as const;

export const insertClaimItemDamages = (payload) =>
  ({
    type: ClaimAction.INSERT_CLAIM_ITEM_DAMGES,
    payload,
  }) as const;

export const setClaimInfo = (payload) =>
  ({
    type: ClaimAction.SET_CLAIM_INFO,
    payload,
  }) as const;

export const submitClaim = () =>
  ({
    type: ClaimAction.SUBMIT_CLAIM,
  }) as const;

export const fetchClaimInfo = (payload) =>
  ({
    type: ClaimAction.FETCH_CLAIM_INFO,
    payload,
  }) as const;

export const cleanUpClaimInfo = () =>
  ({
    type: ClaimAction.CLEAN_UP,
  }) as const;

export const deleteClaimCreateNew = (payload) =>
  ({
    type: ClaimAction.DELETE_CLAIM_CREATE_NEW,
    payload,
  }) as const;

export const handleClaimItemFileUpload = (payload) =>
  ({
    type: ClaimAction.CLAIM_ITEM_FILE_UPLOAD,
    payload,
  }) as const;

export const removeClaimItemImage = (payload) =>
  ({
    type: ClaimAction.CLAIM_ITEM_DELETE_DOCUMENT,
    payload,
  }) as const;

export const updateCustomerInfo = (payload) =>
  ({
    type: ClaimAction.UPDATE_CUSTOMER_INFO,
    payload,
  }) as const;

export const removeClaimItemDamage = (payload) =>
  ({
    type: ClaimAction.DELETE_DAMAGE_ITEM,
    payload,
  }) as const;
